module.exports = __webpack_public_path__ + "static/media/student-submitted.2b51f04e.svg";